import { AttachmentsStatus } from "./attachments-response.interface";

export interface CreateAttachmentsInterface {
  bucket_name: string;
  storage_path: string;
  public_url: string;
  file_type: string;
  file_size: number;
  file_name: string;
  status: AttachmentsStatus;
}

export interface UpdateAttachmentsInterface {
  id: string;
  bucket_name?: string;
  storage_path?: string;
  public_url?: string;
  file_type?: string;
  file_size?: number;
  file_name?: string;
  status?: AttachmentsStatus;
}